import React, { FC } from 'react';
import { ITool } from '../../model/tool';
import { IProject } from '../../model/project';
import { IUser } from '../../model/user';
import { observer } from 'mobx-react-lite';
import styles from './../../../src/routes/users/forms/user-form.module.sass';
import { IamRoles } from '../iam-roles/iam-roles';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { LabelHeader, ProjectLogo } from '@yakoffice/shared-components';
import { IamRolesPopOver } from '../iam-roles/iam-roles-popover';

interface PropTypes {
    projects: IProject[],
    tools: ITool[],
    user: IUser
}

export const UserProjectTabs: FC<PropTypes> = observer(({ projects, tools, user }) => {
    return (
        <div>
            {
                projects
                    .filter(project => project.tools.length > 0)
                    .slice()
                    .sort((p1, p2) => p1.name.localeCompare(p2.name))
                    .map(project => (

                        <div className={`${styles.userFormm}, ${styles.projectHeader}`}>
                            <Row>
                                <Col>
                                    <Form.Label>
                                        <LabelHeader className={styles.projectLabel}>{project.imageUrl &&
                                            <ProjectLogo src={project.imageUrl} />} {project.name}
                                            <span className="ms-2"><IamRolesPopOver /></span></LabelHeader>
                                    </Form.Label>
                                    <IamRoles projectId={project.id} user={user} forceRow={true} />
                                </Col>
                            </Row>
                        </div>
                    ))
            }
        </div>
    );
});
